module.exports = __webpack_public_path__ + "static/scale-model-of-des-moines-art-center-in-des-moines-iowa-66ea2a2057c8e6dfe352f227bce25ceb.png";